var error = {
  translation: {
    error: {
      coreNotFound: 'Error al obtener la configuración principal',
      domainNotAllowed: 'No puedes registrarte con un correo de este dominio',
      emailAlreadyInUse: 'El correo ya está en uso',
      insufficientPermissions: 'Permisos insuficientes',
      invalidCurrentPassword: 'Contraseña actual inválida',
      invalidPermissions: 'Seleccione al menos un permiso',
      invalidUsernameOrPassword: 'Nombre de usuario o contraseña inválidos',
      localRegistrationDisabled: 'El registro local de usuarios está deshabilitado por el administrador',
      noInternetConnection: 'Sin conexión a internet',
      noOidcProfileFound: 'No se encontró perfil OIDC',
      policyNotAccepted: 'Por favor, acepta los Términos de Servicio y la Política de Privacidad',
      registrationDisabled: 'El registro de usuarios está deshabilitado por el administrador',
      serverConnectionFailed: 'Error de conexión con el servidor',
      ssoRegistrationDisabled: 'El registro SSO de usuarios está deshabilitado por el administrador',
      tooManyFailedAttempts: 'Demasiados intentos fallidos - inténtalo de nuevo más tarde',
      unknownError: 'Error desconocido, inténtalo de nuevo más tarde',
      usernameAlreadyInUse: 'El nombre de usuario ya está en uso',
      weakPassword: 'Por favor usa una contraseña más fuerte',
    },
  },
};

export { error as default };
